<template>
  <div
    class="mb-4 tablet-h:mb-5 flex flex-col tablet-h:flex-row-reverse tablet-h:justify-between tablet-h:items-start tablet-h:max-w-[1340px] tablet-h:mx-auto tablet-h:w-full"
  >
    <!-- Badge: stacked on top on mobile, floated right on desktop -->
    <div v-if="file" class="mb-4 tablet-h:mb-0 shrink-0">
      <DacrBadge class="h-9 tablet-h:h-[46px] w-auto" />
    </div>
    <Skeleton
      v-else
      class="w-[141px] h-9 tablet-h:w-[180px] tablet-h:h-[46px] mb-4 tablet-h:mb-0 shrink-0"
    />

    <!-- Title + pill -->
    <div class="flex flex-col items-start min-w-0">
      <template v-if="file">
        <div
          class="font-medium text-gray-800 text-[26px] leading-[32px] tablet-h:text-[30px] tablet-h:leading-[40px] [word-break:break-word]"
        >
          {{ file.name }}
        </div>

        <Pill v-if="file?.settings.isPrivate" class="mt-2">
          Private copyright registration
        </Pill>
      </template>

      <Skeleton v-else class="w-[296px] h-[26px]" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Pill, Skeleton } from '@dacr/library'
import DacrBadge from '@/assets/svg/other/DacrBadge.svg'
import type { CopyrightFile } from '@/features/copyright/composables/useCopyrightFile'

defineProps<{
  file?: CopyrightFile
}>()
</script>
